(ns frontend.actions.sale-agreement
  (:require [frontend.conn :as conn]
            [promesa.core :as p]
            [frontend.logging :as logging]))

;; NOTE
;; Should be one-to-one mapping with domain/account
;; No other tasks should be performed here
;; Should only be required in `events` files
;; Function signatures should always be
;; [data on-success! on-error!]
;; Keep it Simple and Silly

(defn *->assign-customer-number [data on-success! on-error!]
  (-> (conn/sendp! :sale-agreement/assign-customer-number
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

